﻿/**
 * portal-favorites.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('portal-favorites.controller', portalFavoritesController);

	/** setup injection */
	portalFavoritesController.$inject = ['toastr', 'portal-favorites.manager'];

	/** implementation */
	function portalFavoritesController(toastr, portalFavoritesManager) {
		/** pubic properties */
		var vm = this;
		vm.loading = false;
		vm.favorites = [];

		/** public methods */
		vm.reorder = reorder;

		/** run init */
		init();

		/** public method implementations */

		/** reorder the user favorites */
		function reorder() {
			/** set the order number value */
			angular.forEach(vm.favorites, function(fav, index) {
				fav.favoriteOrderNumber = (index + 1);
			});

			/** save the reordered extension types */
			portalFavoritesManager.reorderFavorites(vm.favorites).then(function() {
				/** show success message */
				toastr.success('Favorites reordered successfully.', 'Save Successful', { positionClass: 'toast-bottom-right' });
			});
		}

		/** private methods */

		/** initialize */
		function init() {
			/** flip loading flag */
			vm.loading = true;

			/** get the user favorites */
			portalFavoritesManager.getFavorites().then(function(favorites) {
				/** set favorites */
				vm.favorites = favorites;

				/** set the favorites callback */
				portalFavoritesManager.addCallback('portal-favorites', setFavorites);

				/** flip loading flag */
				vm.loading = false;
			});
		}

		/** callback for favorites */
		function setFavorites(favorites) {
			/** set the favorites */
			vm.favorites = favorites || [];
		}
	}
})();